import React from 'react'
import Svg, { G, Path, SvgProps } from 'react-native-svg'

import { Color } from '../../style'

export interface Props extends SvgProps {}
const IconTarget = (props: Props) => {
  const { width, height, color, ...otherProps } = props
  return (
    <Svg
      width={width}
      height={height}
      viewBox={`0 0 ${IconTarget.dimensions.width} ${IconTarget.dimensions.height}`}
      {...otherProps}
    >
      <G fill={color || Color.premiumBlack} fillRule="nonzero">
        <Path d="M12.025 12.236l.092.008a.594.594 0 010 1.186.594.594 0 01-.585-.497l-.008-.096a.567.567 0 00-1.134 0 1.728 1.728 0 003.454 0c0-.954-.773-1.726-1.727-1.727a.567.567 0 00-.092 1.126z" />
        <Path d="M12.21 11.118l-.093-.008a.594.594 0 010-1.186c.295 0 .539.215.585.497l.008.096a.567.567 0 101.134 0 1.728 1.728 0 00-3.454 0c0 .954.773 1.726 1.727 1.727a.567.567 0 00.092-1.126z" />
        <Path d="M12.684 9.187v-.5a.567.567 0 00-1.134 0v.5a.567.567 0 001.134 0zM12.684 14.647v-.49a.567.567 0 00-1.134 0v.49a.567.567 0 001.134 0z" />
        <Path d="M12.117 5.24a6.477 6.477 0 110 12.954 6.477 6.477 0 010-12.954zm0 1.134a5.343 5.343 0 100 10.686 5.343 5.343 0 000-10.686z" />
        <Path d="M12.117 1.38c5.709 0 10.337 4.628 10.337 10.337s-4.628 10.337-10.337 10.337S1.78 17.426 1.78 11.717 6.408 1.38 12.117 1.38zm0 1.134a9.203 9.203 0 100 18.406 9.203 9.203 0 000-18.406z" />
        <Path d="M.567 12.504h4.07a.567.567 0 100-1.134H.567a.567.567 0 100 1.134zM19.237 12.504h4.07a.567.567 0 100-1.134h-4.07a.567.567 0 100 1.134zM11.37.567v4.07a.567.567 0 101.134 0V.567a.567.567 0 10-1.134 0zM11.37 19.237v4.07a.567.567 0 101.134 0v-4.07a.567.567 0 10-1.134 0z" />
      </G>
    </Svg>
  )
}

IconTarget.dimensions = {
  width: 24,
  height: 24,
}

export default IconTarget
